export default __webpack_public_path__ + "static/media/Inter-SemiBold.6058d3da.ttf";